import React from 'react';
import { FacetProps } from '../Facets';
import { FacetItem } from '../../../../types/Search';
import {FilterItem} from '../FilterItem';

import "./KeywordFacet.scss";

export type KeywordFacetProps = FacetProps & {
  // Allows to provide custom labels for each facet item
  // without the need of custom keyword facets implementations
  labelResolver?: (key: string) => string
}

/**
 * Component which renders list of items where each item represents a keyword
 * as returned by the search aggregation.
 * Each keyword can be selected or deselected via checkbox.
 */
class KeywordFacet extends React.Component<KeywordFacetProps> {

  private readonly onSelect = (key: string) => {
    const {data, fieldType, field, facetType} = this.props.model;
    const selectedItem: FacetItem = data[key];
    if (selectedItem.selected) {
      this.props.onDeselect(key);
    } else {
      this.props.onSelect({key, field, fieldType, facetType, value: selectedItem.key});
    }
  };

  render() {
    const {data} = this.props.model;
    return <div className="KeywordFacet">
      <ul>
        {
          Object.keys(data).map((key: string) => {
            const item: FacetItem = data[key];
            const label = this.props.labelResolver ? this.props.labelResolver(key) : item.key;
            return <FilterItem key={key}
                               item={item}
                               itemKey={key}
                               customLabel={label}
                               onSelectEventHandler={() => this.onSelect(key)} />
          })
        }
      </ul>
    </div>
  }
}

export default KeywordFacet;
